import {Component, ElementRef, EventEmitter, Input, Output, signal, ViewChild} from '@angular/core';

@Component({
  selector: 'app-file-upload',
  imports: [],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss'
})
export class FileUploadComponent {
  @Input({required: true}) inputId!: string;
  @Input() accept = '';
  @Input() prompt = 'ลากไฟล์มาวาง หรือคลิกเพื่อเลือก';
  @Input() hint = 'PDF, PNG, JPG ขนาดไม่เกิน 5 MB';
  @Input() disabled = false;

  @Output() fileSelected = new EventEmitter<File | null>();

  @ViewChild('fileInput', {static: true}) private fileInput!: ElementRef<HTMLInputElement>;

  readonly selectedFileName = signal<string | null>(null);
  readonly isDragging = signal(false);

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0] ?? null;

    this.selectedFileName.set(file?.name ?? null);
    this.fileSelected.emit(file);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    if (!this.disabled) {
      this.isDragging.set(true);
    }
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragging.set(false);
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging.set(false);

    if (this.disabled) {
      return;
    }

    const file = event.dataTransfer?.files?.[0] ?? null;
    if (!file) {
      return;
    }

    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    this.fileInput.nativeElement.files = dataTransfer.files;
    this.selectedFileName.set(file.name);
    this.fileSelected.emit(file);
  }
}
